import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getSaved, toggleSaved, clearSaved } from "@/lib/watchLater";
import { useAuth, syncSaved } from "@/context/AuthContext";

// Guests are prompted to sign in when saving — except in the Kids Hub, where saves stay local with no prompt.
export const useWatchLater = () => {
  const [ids, setIds] = useState(getSaved());
  const { pathname } = useLocation();
  const { user, openSignIn } = useAuth();

  useEffect(() => {
    const handler = () => setIds(getSaved());
    window.addEventListener("watchlater-change", handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener("watchlater-change", handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  const toggle = (id, { kids = false } = {}) => {
    const isKids = kids || pathname.startsWith("/kids");
    if (!user && !isKids) {
      openSignIn("save", ids.includes(id) ? null : id);
      return ids;
    }
    const wasSaved = ids.includes(id);
    const next = toggleSaved(id);
    if (user) syncSaved(wasSaved ? "remove" : "add", id);
    return next;
  };

  const clear = () => {
    clearSaved();
    if (user) syncSaved("clear");
  };

  return { ids, isSaved: (id) => ids.includes(id), toggle, clear };
};
